import React from 'react';
import { TextLink } from '@oneaudi/unified-web-components';
export function parseWithLinks(input) {
    const regex = /\$\{([^|}]+)\|([^}]+)\}/g;
    const parts = [];
    let lastIndex = 0;
    let match;
    while ((match = regex.exec(input)) !== null) {
        const [placeholder, label, url] = match;
        if (match.index > lastIndex) {
            parts.push(input.slice(lastIndex, match.index));
        }
        parts.push(React.createElement(TextLink, { className: "className", href: url.trim(), "data-placeholder": placeholder, id: "id", rel: "noopener", size: "sm", target: "_self", variant: "inline" }, label.trim()));
        lastIndex = regex.lastIndex;
    }
    if (lastIndex < input.length) {
        parts.push(input.slice(lastIndex));
    }
    return parts;
}
